module.exports = __webpack_public_path__ + "static/media/ruby.d341bf8e.png";